import * as CubeTree from '../cubeTree/index';
import { cubeModify } from './cubeModify';
import { getLayerLayoutUpadteQueue } from './getLayerLayoutUpadteQueue';

function runTaskQueue(taskQueue: UpdateTask[]): void {
    taskQueue.forEach((updateTask: UpdateTask): void => {
        // 修改cube数据
        cubeModify(updateTask.cubeId, updateTask.updateData);
    });

    // 查询编组层板的关联更新任务
    let extraneousLayerTaskQueue: UpdateTask[] = getLayerLayoutUpadteQueue(taskQueue);

    extraneousLayerTaskQueue.forEach((updateTask: UpdateTask): void => {
        // 修改cube数据
        cubeModify(updateTask.cubeId, updateTask.updateData);
    });
}

export {
    runTaskQueue
};
